import styled, { css } from 'styled-components';
import { withMargins, withColors } from '../../mixins';
import { textDefaultProps } from './props';
const withVariants = ({ variant, italic, weight }) => {
    const variants = {
        'display-large': css `
      font-weight: var(--font-weight-bold);
      line-height: var(--font-lineheight-tight);
      font-size: var(--font-size-xxl);

      @media screen and (min-width: 600px) {
        font-size: var(--font-size-huge);
      }
    `,
        'display-medium': css `
      font-weight: var(--font-weight-bold);
      line-height: var(--font-lineheight-tight);
      font-size: var(--font-size-xl);

      @media screen and (min-width: 600px) {
        font-size: var(--font-size-xxxl);
      }
    `,
        'title-large': css `
      font-weight: var(--font-weight-semibold);
      line-height: var(--font-lineheight-medium);
      font-size: var(--font-size-lg);

      @media screen and (min-width: 600px) {
        font-size: var(--font-size-xxl);
      }
    `,
        'title-medium': css `
      font-weight: var(--font-weight-semibold);
      line-height: var(--font-lineheight-medium);
      font-size: var(--font-size-md);

      @media screen and (min-width: 600px) {
        font-size: var(--font-size-lg);
      }
    `,
        'title-small': css `
      font-weight: var(--font-weight-bold);
      line-height: var(--font-lineheight-medium);
      font-size: var(--font-size-sm);

      @media screen and (min-width: 600px) {
        font-size: var(--font-size-md);
      }
    `,
        'subtitle-large': css `
      font-weight: var(--font-weight-regular);
      line-height: var(--font-lineheight-medium);
      font-size: var(--font-size-md);

      @media screen and (min-width: 600px) {
        font-size: var(--font-size-lg);
      }
    `,
        'subtitle-medium': css `
      font-weight: var(--font-weight-regular);
      line-height: var(--font-lineheight-medium);
      font-size: var(--font-size-sm);

      @media screen and (min-width: 600px) {
        font-size: var(--font-size-md);
      }
    `,
        'body-large': css `
      font-weight: ${() => `var(--font-weight-${weight})`};
      line-height: var(--font-lineheight-superdistant);
      font-size: var(--font-size-sm);
      font-style: ${italic ? 'italic' : 'normal'};
    `,
        'body-medium': css `
      font-weight: ${() => `var(--font-weight-${weight})`};
      line-height: var(--font-lineheight-superdistant);
      font-size: var(--font-size-xs);
      font-style: ${italic ? 'italic' : 'normal'};
    `,
        'body-small': css `
      font-weight: ${() => `var(--font-weight-${weight})`};
      line-height: var(--font-lineheight-distant);
      font-size: var(--font-size-xxs);
      font-style: ${italic ? 'italic' : 'normal'};
    `,
        caption: css `
      font-weight: ${() => `var(--font-weight-${weight})`};
      line-height: var(--font-lineheight-medium);
      font-size: var(--font-size-xxxs);
    `,
        overline: css `
      line-height: var(--font-lineheight-supertight);
      font-size: var(--font-size-nano);
      text-transform: uppercase;
    `,
    };
    return variants[variant];
};
export const InnerText = styled.span `
  display: ${({ $display = textDefaultProps.display }) => $display};
  ${({ textTransform }) => (textTransform ? `text-transform: ${textTransform};` : '')}
  margin: 0;
  padding: 0;
  font-weight: var(--font-weight-regular);
  font-style: normal;
  font-family: var(--font-family);
  word-break: break-word;
  color: var(--text-color);

  ${withVariants}
  ${(props) => props.$color && withColors({ color: props.$color })}
  ${withMargins}
`;
